import { sharedComponentErrorMessage } from "#/admin/legacy/page-builder/shared-component-errors.js";
import { sharedComponentFilterItems } from "#/admin/legacy/page-builder/shared-component-filters.js";
import "#legacy/admin/form.js";

(function (
  findTemplate,
  Component,
  Tool,
  assert,
  toolKeysForComponent,
  Section,
  SharedComponent,
  moment,
  numColumns,
  deepCopy,
  Search,
  event,
  Override,
) {
  "use strict";

  // Base View that each sidebar view should extend
  function SidebarView() {
    return {
      extend: function (object) {
        return jQuery.extend(this, object);
      },
      cssClass: "",
      unload: function () {},
      save: function () {},
      cancel: function () {},
      load: function () {},
      hide: function () {},
      show: function () {},
      bind: function () {},
      unbind: function () {},
      render: function () {},
    };
  }

  /**
   * Essentially the same view as EditComponent, but includes controls
   * for overriding shared content and settings at the page level.
   */
  function EditSharedComponent(page, component, sidebar) {
    var base = EditComponent(page, component, sidebar);
    base.template = findTemplate("shared-component");

    /**
     * Override the base save method from the EditComponent class, but this time
     *  we make sure to go ahead and trigger a modal warning, and subsequent
     *  ajax call which updates the shared component. If there are no changes
     *  detected at this time, then we want to go ahead and just collapse the
     *  sidebar and do nothing.
     * @override EditComponent.save
     */
    base.save = function () {
      var me = this,
        component = me.page.component;
    };

    base.render = function () {
      var me = this,
        templateVariables = this.createTemplateVariables();
      this.element.innerHTML = this.template(templateVariables);
      this.tools = Tool.Loader(component, this.element, page.config);

      me.page.component.stamp("tools-loaded");

      // hide warning div
      jQuery(this.element).find(".saved-warning").hide();

      // show tools and settings divs
      jQuery(this.element).find(".loaded-tools").show();
      jQuery(this.element).find(".loaded-behavior").show();
    };

    base.bind = function () {
      var $element = jQuery(this.element);

      jQuery('[role="tab"]:checked').trigger("change");

      // configuration actions
      $element.find(".delete-component").on("click", this.deleteComponent.bind(this));
      $element.find(".convert-component").on("click", this.convertToInline.bind(this));
      $element.find(".update-shared").on("click", this.pushToShared.bind(this));

      this.tools = base.tools;
      this.tools.load();
      this.page.component.stamp("tools-loaded");

      // show tools and settings divs
      jQuery(this.element).find(".loaded-tools").show();
      jQuery(this.element).find(".loaded-behavior").show();
    };

    /**
     * @name convertToInline
     * @description
     *  Convert the current component instance from a shared instance to an
     *   inline component instance through the page builder SharedComponent
     *   api.
     * @see SharedComponent.inline
     */
    base.convertToInline = function () {
      var originalPosition = component.position(),
        replacement = Sparkle.PageBuilder.SharedComponent.inline(this.page.component, this.page.config);

      jQuery(this.page.component.element).replaceWith(jQuery(replacement.element));

      this.page.component.section.insert(originalPosition, replacement);

      // we already know how many columns this component should be, because
      // it existed on the page previously, so we'll manually set it.
      replacement.setColumns(component.columns());

      this.page.component.section.completeRemove(this.page.component);

      // we need to do this to get any new component in the right row.
      replacement.section.reflow();

      // people use the menus in the sidebar to convert shared components to
      // unique components, and we don't want that menu to collapse, but want
      // it to reopen with it's focus on the new unique component. this also
      // has the pleasant side effect of addressing some component lifecycle
      // bugs, like slideshows being left uninitialized after being convert
      // from a shared component.
      jQuery(replacement.element).trigger("click");
    };

    /**
     * @name pushToShared
     * @description
     *  Push any inline customizations to the shared component.
     * @see SharedComponent.inline
     */
    base.pushToShared = function () {
      var current = component;

      Sparkle.PageBuilder.Dialog.show(
        {
          title: "Update Shared Content",
          text: "Default content for this component will be replaced with \
          overrides from this instance. Changes will be applied everywhere \
          this component is used, except where they are overridden. <br/><br/> \
          Are you sure you want to continue?",
          html: true,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#5aadca",
          confirmButtonText: "Yes, Update Shared Content",
          cancelButtonText: "Cancel",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function () {
          component.push().always(function () {
            // reload the entire edit component view.
            // this is the most reliable way to ensure the ui updates properly.
            sidebar.editComponent(current.element);
          });
        }.bind(this),
      );
    };

    base.deleteComponent = function () {
      var me = this,
        component = me.page.component;

      Component.removeWithConfirmation(component);
    };

    return base;
  }

  /**
   * Coordinates loading and unloading of tools and binding tools
   * to component splinters.
   * @memberof page-builder
   * @constructs EditComponent
   * @param {Page} page - An instance of Page
   * @param {Sidebar} sidebar - An instance of the sidebar
   */
  function EditComponent(page, component, sidebar) {
    var element = jQuery(sidebar.element).find("#component-settings-container")[0];

    function deleteComponent() {
      var me = this,
        component = me.page.component;

      Component.removeWithConfirmation(component);
    }

    function convertToShared() {
      var me = this,
        component = me.page.component,
        componentData = component.data(),
        defaultName = null;

      // Attempt to inherit the name from the componentData if applicable,
      //  otherwise we just leave it as null so they can enter it in the
      //  modal.
      if (_.isObject(componentData.context.title)) {
        defaultName = componentData.context.title.text;
      } else if (_.isString(componentData.context.title)) {
        defaultName = componentData.context.title;
      }

      Sparkle.PageBuilder.Dialog.show(
        {
          title: "Confirm Conversion",
          text: [
            "Are you sure you want to convert this component to a shared component?",
            "Enter a name for the new shared component and then press confirm to save.",
          ].join(" "),
          type: "input",
          showCancelButton: true,
          confirmButtonColor: "#5aadca",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",

          // this is disabled so we can do validations in the callback.
          closeOnConfirm: false,

          closeOnCancel: true,
          inputPlaceholder: "Name",
          inputValue: "",
        },
        function (sharedComponentName) {
          // if the user didn't cancel, but didn't provide a name ..
          if (sharedComponentName === "") {
            swal.showInputError("You must supply a name.");
          } else if (sharedComponentName) {
            // We don't want to store inline component attributes in the
            // shared component's data, so we delete those keys now.
            var sharedComponentData = deepCopy(componentData);
            delete sharedComponentData["columns"];

            // Reset the key for this component so that it can be tracked correctly
            SharedComponent.convertToShared(sharedComponentName, sharedComponentData, me.page.config).then(
              function (newSharedComponent) {
                if (newSharedComponent.errors) {
                  swal.showInputError(sharedComponentErrorMessage(newSharedComponent.errors));
                  return;
                }

                // we need to manually close the sweet alert.
                swal.close();

                var originalPosition = component.position();

                // Add the original component's columns value to the new shared component.
                newSharedComponent.setColumns(componentData.columns);

                jQuery(component.element).replaceWith(jQuery(newSharedComponent.element));

                component.section.completeRemove(component);
                component.section.insert(originalPosition, newSharedComponent, {}, { skipValidation: true });
                component.section.reflow();

                // automatically select the new shared component and open the sidebar.
                // this is a really logical workflow for users, who were already using the
                // sidebar to trigger this conversion to a shared component. it also
                // addresses some component lifecycle issues that leave new components
                // rendering oddly after conversion.
                sidebar.editComponent(newSharedComponent.element);
              },
            );
          }
        },
      );
    }

    return SidebarView().extend({
      cssClass: "edit-component",
      template: findTemplate("edit-component"),
      page: page,
      tools: Tool.Loader(component, element, page.config),
      config: [],
      element: element,
      unload: function () {
        this.tools.unload();
        this.tools = null;
        this.config = [];
      },

      createTemplateVariables: function () {
        // If the component is not inheritable by child pages, don't show inheritors that inherit for that reason
        var inheritors = Component.metadata.inheritors.filter(function (inheritor) {
          return component.data("inheritable") ? true : inheritor.inheritance_reason != "child";
        });

        var created = moment(component.data("created_at")),
          updated = moment(component.data("updated_at")),
          templateVariables = {
            description: this.page.component.config.description,
            name: this.page.component.config.name || "",
            inherited: this.page.component.inherited,
            unsynced: component.rendered.unsynced,
            inheritors: inheritors,
            inheritorCount: inheritors.length,
            hasInheritors: !!inheritors.length,
            componentTitle: component.context.title,
            inheritedFromURL: this.page.component.rendered.inherited_from_url,
            replaces: this.page.component.rendered.inherited_from,
            componentName: component.data("name"),
            componentId: component.data("id"),
            audit: {
              created_at: created.isValid() ? created.format("MMMM Do, YYYY") + " at " + created.format("h:mm A") : "",
              updated_at: updated.isValid() ? updated.format("MMMM Do, YYYY") + " at " + updated.format("h:mm A") : "",
            },
          };

        // there may be one or more images associated with this component.
        templateVariables["images"] = [];

        // for each of the attributes of this component that are images..
        var imageKeys = toolKeysForComponent(this.page.component.config, "image-editor");

        // include the image information in the template variables.
        imageKeys.forEach(function (imageKey) {
          var imageContext = component.context[imageKeys[0]] || {};
          if (imageContext["url"]) {
            templateVariables["images"].push(imageContext);
          }
        });

        return templateVariables;
      },

      // we use this specifically to update the image info
      // after a new photo has been uploaded.
      updateImageDetails: function () {
        var templateVariables = this.createTemplateVariables();
        var html = this.template(templateVariables);
        var selector = "#info-and-actions-content .info-content";
        jQuery(this.element).find(selector).replaceWith(jQuery(html).find(selector));
      },

      render: function () {
        var me = this,
          templateVariables = this.createTemplateVariables();

        this.element.innerHTML = this.template(templateVariables);
        this.tools.load();

        // Hide tabs that have no tools for the given component
        // Note: Not using `.find('.loaded-tools-wrapper:empty')` since the
        // appearance/style tab always has a <div> element as a child,
        // even if it does not have any content itself
        jQuery(this.element)
          .find(".loaded-tools-wrapper")
          .each(function () {
            if (jQuery(this).text().trim() == "") {
              var tabContentId = jQuery(this).closest(".tab-content").attr("id");
              var tabLabelSelector = 'label[for="' + tabContentId.replace("_content", "") + '"]';
              jQuery(me.element).find(tabLabelSelector).hide();
            }
          });
      },

      cancel: function () {
        var me = this;
        if (me.page.component.changed("tools-loaded")) {
          Sparkle.PageBuilder.Dialog.show(
            {
              title: "Confirm Cancel",
              text: "Are you sure you want to cancel? All changes will be lost!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#5aadca",
              confirmButtonText: "Discard Changes",
              cancelButtonText: "Keep Working",
              closeOnConfirm: true,
              closeOnCancel: true,
            },
            function () {
              me.page.rollback();
            },
          );
        }
      },

      save: function () {
        this.page.save();
      },

      bind: function () {
        var me = this;

        me.page.component.stamp("tools-loaded");

        jQuery(this.element).find('[role="tab"]:checked').trigger("change");
        // component actions : delete & convert to shared
        jQuery(this.element).on("click", ".delete-component", deleteComponent.bind(this));
        jQuery(this.element).on("click", ".convert-component", convertToShared.bind(this));
        jQuery(this.element).on("click", ".inheritor-count", function () {
          jQuery(me.element).find("#info-and-actions-content").show();
          return false;
        });

        // when new images are selected or uploaded, we need to update
        // the image details we've already rendered.
        event.on("pb:tool:image:updated", this.updateImageDetails, this);
      },

      unbind: function () {
        jQuery(this.element).off();
        event.off(null, null, this);
      },
    });
  } // end EditComponent

  function NewComponent(page, sidebar) {
    var element = jQuery(sidebar.element).find("#page-components-tab-content")[0];
    var search = Search();
    var actionsMenuTrigger =
      jQuery(`<div data-sidebar-action="show-actions-menu" class="edit-component-actions unhide-inherited-components left">
          <svg class="icon icon-configure"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${iconSpriteUrl()}#icon-configure"></use></svg>
         </div>`);
    var actionsMenu = jQuery(`<div class="component-actions-menu">
           <p>This page contains inherited components that have been hidden or moved from their default positions.</p>
           <div class="component-actions-menu-options">
             <a data-sidebar-action="unhide-inherited-components" href="javascript:void(0)" class="component-action-button undelete-components">
              <sp-icon name="hide-color"></sp-icon>
               Unhide all
             </a>
           </div>
         </div>`);

    // EVENT HANDLERS

    function handleSharedComponentInfoClick(event) {
      var componentId = jQuery(this).closest("[data-component-id]").data("component-id");
      new Sparkle.PageBuilder.SharedInfoDialog(componentId);
    }

    // HELPER FUNCTIONS

    function unhideInheritedComponents() {
      Section.unhideAll();
      renderActionsMenu();
    }

    function renderActionsMenu() {
      if (Section.hasHidden()) {
        jQuery(element).prepend(actionsMenuTrigger);
      } else {
        actionsMenuTrigger.detach();
      }
    }

    // INITITALIZE

    actionsMenuTrigger.append(actionsMenu);

    return SidebarView().extend({
      element: element,
      template: findTemplate("new-component"),
      search: search,
      sharedComponents: [],
      bind: function () {
        jQuery(element).on("click", "[data-sidebar-action=show-actions-menu]", function () {
          jQuery(this).toggleClass("--active");
        });
        jQuery(element).on("click", "[data-sidebar-action=unhide-inherited-components]", unhideInheritedComponents);
        jQuery(element).on("click", ".shared-component-info", handleSharedComponentInfoClick);
        event.on("pb:section:remove", renderActionsMenu, this);
        renderActionsMenu();
      },
      unbind: function () {
        jQuery(element).off();
        event.off(null, null, this);
      },
      show: function () {
        // Highlight the search input after the click has completed so it doesn't immediately get cleared
        setTimeout(function () {
          jQuery("#sharedSearch").select();
        }, 100);
      },
      render: function () {
        var me = this;
        this.loadComponents().then(
          function () {
            this.fetchFilters().then(
              function () {
                var templates = _.filter(_.values(page.config), function (template) {
                  return template.active;
                });

                // Sort components by their sort name
                templates.sort(function (a, b) {
                  a = a.sort_name.toLowerCase();
                  b = b.sort_name.toLowerCase();
                  if (a == b) {
                    return 0;
                  }
                  if (a > b) {
                    return 1;
                  }
                  if (a < b) {
                    return -1;
                  }
                });

                // if components are not supported display overlay
                var componentsNotSupported = _.isEmpty(Sparkle.PageBuilder.Section.instances);
                if (componentsNotSupported) {
                  jQuery("#page-edit-pane .components-not-supported").css("display", "flex");
                }

                jQuery(element).html(
                  me.template({
                    templates: templates,
                    shared: me.sharedComponents,
                    ...sharedComponentFilterItems(me.labels, window.PAGE_BUILDER_FILTER_ITEMS),
                  }),
                );
                Form.decorateSelects(element);
                search.bind(
                  "#sharedSearch",
                  "#shared-components-search-and-filter select, #shared-components-search-and-filter sp-select",
                  "#shared-components_fieldset_content",
                  "#searchMessage",
                  me.sharedComponents,
                );
                renderActionsMenu();
              }.bind(this),
            );
          }.bind(this),
        );
      },
      fetchFilters: function (reload) {
        var deferred = jQuery.Deferred();
        if (reload || _.isEmpty(this.labels)) {
          jQuery
            .get("/admin/labels.json")
            .then(
              function (response) {
                this.labels = response;
                deferred.resolve(this.labels);
              }.bind(this),
            )
            .fail(
              // The labels are only the filter options — render the component selector
              // without them rather than leaving the sidebar blank.
              function () {
                console.error("AJAX call failed for labels");
                this.labels = [];
                deferred.resolve(this.labels);
              }.bind(this),
            );
        } else {
          deferred.resolve(this.labels);
        }
        return deferred.promise();
      },
      loadComponents: function () {
        return SharedComponent.fetchAll()
          .then(
            function (components) {
              this.sharedComponents = _.values(components).map(function (component) {
                return {
                  description: component.description || "need a description",
                  id: component.id,
                  role: component.role,
                  template: component.template,
                  icon_name: component.icon_name,
                  template_name: component.template_name,
                  name: component.name,
                  label_ids: component.label_ids,
                  // VITE_MIGRATION: API returns dates as `MM/DD/YYYY` strings
                  // (US format) which moment can't auto-parse — pass an explicit
                  // input format to silence the deprecation warning.
                  created_at: moment(component.created_at, "MM/DD/YYYY").format("MM/DD/YYYY"),
                  updated_at: moment(component.updated_at, "MM/DD/YYYY").format("MM/DD/YYYY"),
                  created_at_timestamp: component.created_at_timestamp,
                  updated_at_timestamp: component.updated_at_timestamp,
                  component_assignments_count: component.component_assignments_count,
                };
              });
            }.bind(this),
          )
          .fail(function () {
            console.error("Failed to fetch components");
          });
      },
    });
  } // end NewComponent

  /**
   * @memberof page-builder
   * @constructs Sidebar
   */
  function Sidebar(page, element) {
    var loaded = SidebarView();
    var showing = false;
    var iframe = jQuery(page.iframe);
    var publicInterface = {
      changeTab: changeTab,
      element: element,
      page: page,
      setPage: setPage,
      done: done,
      save: save,
      cancel: cancel,
      toggle: toggle,
      show: show,
      hide: hide,
      showDefaultView: showDefaultView,
      editComponent: editComponent,
      isEditingComponent: isEditingComponent,
      load: load,
      unload: unload,
      render: render,
    };
    var defaultView = NewComponent(page, publicInterface);

    // BEHAVIOUR
    jQuery(element).on("click", "[data-sidebar-action=done]", done);
    jQuery(element).on("click", "[data-sidebar-action=toggle]", toggle);
    jQuery(element).on("click", "[data-sidebar-action=changeTab]", handleChangeTab);

    return publicInterface;

    // EVENTS

    function handleChangeTab(event) {
      Sparkle.Tabs.selectTab(event.currentTarget);
    }

    // HELPER FUNCTIONS

    function setPage(newPage) {
      page = newPage;
      publicInterface.page = newPage;
      showing ? show() : hide(); // Initialize new page state, e.g. classes
    }

    function changeTab(tab) {
      jQuery(element).find("[data-sidebar-action=changeTab]").removeClass("active");
      jQuery(element).find(".sidebar-tab.active").removeClass("active");
      jQuery(tab).addClass("active");

      jQuery(element)
        .find(".sidebar-tab-" + jQuery(tab).data("sidebar-tab-id"))
        .addClass("active");
    }

    function done() {
      loaded.save();
      showDefaultView();
    }

    function save() {
      loaded.save();
    }

    function cancel() {
      loaded.cancel();
    }

    function toggle() {
      showing ? hide() : show();
    }

    function show() {
      showing = true;
      toggleEditingClass(true);
      toggleVisibilityClasses([element, iframe, iframe.parent()], true);
      loaded.show();
      event.trigger("pb:sidebar:show");
    }

    function hide() {
      showing = false;
      toggleEditingClass(false);
      toggleVisibilityClasses([element, iframe, iframe.parent()], false);
      loaded.hide();
      event.trigger("pb:sidebar:hide");
    }

    function toggleVisibilityClasses(elements, showing) {
      jQuery(elements).toggleClass("showing", showing).toggleClass("hiding", !showing);
      jQuery(iframe.parent()).toggleClass("showing", showing).toggleClass("hiding", !showing);
    }

    function toggleViewClass(view, showing) {
      jQuery(element).toggleClass(view.cssClass, showing);
    }

    function toggleEditingClass(editing) {
      jQuery(page.element).closest("html").toggleClass("active-editing", editing);
    }

    function toggleComponentEditingClass(editing) {
      if (page.component) {
        jQuery(page.component.element).toggleClass("component-active", editing);
      }
    }

    function showDefaultView() {
      toggleComponentEditingClass(false);
      page.unload();
      load(defaultView);
      show();
    }

    function editComponent(componentElement) {
      var component = Component.find(componentElement);
      toggleComponentEditingClass(false);
      page.load(component);
      toggleComponentEditingClass(true);

      if (component.shared) {
        load(EditSharedComponent(page, component, publicInterface));
      } else {
        load(EditComponent(page, component, publicInterface));
      }

      show();
    }

    function isEditingComponent(componentElement) {
      return page.component == Component.find(componentElement) || (!page.component && !componentElement);
    }

    function load(view) {
      unload();
      loaded = view;
      toggleViewClass(loaded, true);
      loaded.load();
      // Avoid re-rendering already rendered views (e.g. the defaultView)
      if (!loaded.rendered) {
        render();
        loaded.rendered = true;
      }
      bind();
    }

    function unload() {
      loaded.unload();
      toggleViewClass(loaded, false);
      unbind();
      loaded = null;
    }

    function bind() {
      loaded.bind();
    }

    function unbind() {
      loaded.unbind();
    }

    function render() {
      loaded.render();
    }
  } // end Sidebar

  // export
  Sparkle.PageBuilder.EditSharedComponentView = EditSharedComponent;
  Sparkle.PageBuilder.EditComponentView = EditComponent;
  Sparkle.PageBuilder.NewComponentView = NewComponent;
  Sparkle.PageBuilder.Sidebar = Sidebar;
})(
  Sparkle.PageBuilder.Templates.findTemplate,
  Sparkle.PageBuilder.Component,
  Sparkle.PageBuilder.Tool,
  Sparkle.PageBuilder.Helpers.assert,
  Sparkle.PageBuilder.Helpers.toolKeysForComponent,
  Sparkle.PageBuilder.Section,
  Sparkle.PageBuilder.SharedComponent,
  window.moment,
  Sparkle.PageBuilder.Helpers.numColumns,
  Sparkle.PageBuilder.Helpers.deepCopy,
  Sparkle.PageBuilder.Helpers.SharedComponentSearch,
  Sparkle.PageBuilder.Helpers.Event,
);
